<template>
  <el-menu
    router
    mode="vertical"
    active-text-color="#1972FF"
    text-color="#08224D"
    :style="`
      width: ${styleData.containerWidth}px;height: ${
      styleData.mainHeight - 80
    }px;border-right: 0 solid #fff;
    `"
    class="elMenuVerticalDemo"
    :collapse="isCollapse"
    :default-openeds="styleData.openeds"
    :default-active="$route.path"
    menu-trigger="click"
  >
    <template v-for="item in menuList">
      <el-submenu
        :disabled="handleDemoDisabled(item.data.url)"
        v-if="item.children && item.children.length"
        :name="item.data && `/${item.data.systemTagName}${item.data.url}`"
        :index="item.data && `/${item.data.systemTagName}${item.data.url}`"
        :key="item.data && `/${item.data.systemTagName}${item.data.url}`"
      >
        <template slot="title">
          <i
            v-if="item.data && item.data.url && ICON[item.data.url]"
            :class="ICON[item.data.url].icon"
          ></i>
          <span slot="title">{{ item.data && item.data.name }}</span>
        </template>
        <template v-for="el in item.children">
          <template v-if="el.children && el.children.length">
            {{ el.data.url }}
            <el-submenu
              :name="el.data && `/${el.data.systemTagName}${el.data.url}`"
              :key="el.data && `/${el.data.systemTagName}${el.data.url}`"
              :index="el.data && `/${el.data.systemTagName}${el.data.url}`"
            >
              <template slot="title">{{ el.data && el.data.name }}</template>
              <el-menu-item
                v-for="row in el.children"
                :key="row.data & `/${row.data.systemTagName}${row.data.url}`"
                :index="row.data && `/${row.data.systemTagName}${row.data.url}`"
              >
                {{ row.data && row.data.name }}
              </el-menu-item>
            </el-submenu>
          </template>
          <template v-else>
            <el-menu-item
              v-if="!el.data.url.includes('preview/h5')"
              :name="el.data && `/${el.data.systemTagName}${el.data.url}`"
              :key="el.data && `/${el.data.systemTagName}${el.data.url}`"
              :index="el.data && `/${el.data.systemTagName}${el.data.url}`"
            >
              <span slot="title">{{ el.data && el.data.name }}</span>
            </el-menu-item>
          </template>
        </template>
      </el-submenu>
      <template v-else>
        <el-menu-item
          v-if="!item.data.url.includes('preview/h5')"
          :disabled="handleDemoDisabled(item.data.url)"
          :index="item.data && `/${item.data.systemTagName}${item.data.url}`"
          :key="item.data && `/${item.data.systemTagName}${item.data.url}`"
        >
          <i
            v-if="item.data && item.data.url && ICON[item.data.url]"
            :class="ICON[item.data.url].icon"
          ></i>
          <span slot="title" :title="item.data && item.data.name">{{
            item.data && item.data.name
          }}</span>
        </el-menu-item>
      </template>
    </template>
  </el-menu>
</template>

<script>
import ICON from "./../config/icon";
export default {
  name: "Submenus",
  props: {
    menuList: {
      type: Array,
      default: () => [],
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
    styleData: {
      type: Object,
      default: {
        openeds: [],
        containerWidth: 160,
        mainHeight: 0,
        mainWidth: 0,
        isWdDemo: false, //是否是一键实施demo
      },
    },
  },
  data() {
    return {
      ICON,
      roleList: [],
    };
  },
  computed: {
    isActor: () => {
      if (+localStorage.getItem("organ") === 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {
    //是否是一键实施demo
    this.isWdDemo = localStorage.getItem("isWdDemo");
    if (localStorage.getItem("token")) {
      this.getFindRoleIds();
    }
  },
  mounted() {},
  methods: {
    // 一键实施demo菜单控制
    handleDemoDisabled(item) {
      if (this.isWdDemo) {
        //一键实施demo
        // 可以操作的菜单：概况总览、用户管理、站点管理
        let canOpeList = [
          "/demo_homepage",
          "/student",
          "/run?id=129&name=自主实施体验租户",
        ];
        return canOpeList.indexOf(item) !== -1 ? false : true;
      } else {
        return false;
      }
    },
    system(url) {
      return url.includes("/live") ||
        url.includes("/talent") ||
        url.includes("/certificate")
        ? "/raas"
        : "/saas";
    },
    treatRole(role) {
      let isRole = false;
      this.roleList.forEach((item) => {
        if (!isRole) {
          isRole = role.some((v) => {
            if (item == v) {
              return true;
            } else {
              return false;
            }
          });
        }
      });
      if (this.$route.query.role == 999) {
        return true;
      } else {
        return isRole;
      }
    },
    getFindRoleIds() {
      this.$api.role.getFindRoleIds({}).then((res) => {
        this.roleList = res.data || [];
        localStorage.setItem("roleList", res.data);
        sessionStorage.setItem("roleList", res.data);
      });
    },
  },
};
</script>

<style lang="stylus" scoped >
/deep/.el-menu {
  span {
    font-size: 14px;
  }
}

/deep/.el-submenu {
  &.is-active {
    .el-submenu__title {
      .iconfont {
        font-weight: 400 !important;
      }

      span {
        font-weight: bold;
      }
    }

    .el-menu--inline {
      .el-menu-item {
        &.is-active {
          background-color: #fff !important;
        }
      }
    }
  }

  .el-submenu__title {
    height: 46px;
    line-height: 46px;
    font-weight: bold;

    .iconfont {
      color: #333333;
      margin-left: -5px;
      font-weight: 400 !important;
    }

    span {
      color: #333333;
      font-weight: 700;
      margin-left: 12px !important;
    }
  }

  .el-menu--inline {
    .el-menu-item {
      height: 40px !important;
      line-height: 40px !important;

      span {
        font-weight: 400 !important;
        margin-left: 12px !important;
        color: #333333;
      }
    }
  }
}

/deep/.el-menu-item {
  height: 40px !important;
  line-height: 40px !important;
  font-weight: 400;

  .iconfont {
    color: #333333;
    margin-left: -5px;
  }

  span {
    color: #333333;
    font-weight: 700;
    margin-left: 12px !important;
  }
}
</style>
<style lang="stylus" scoped >
html[data-theme='red'] {
  .el-submenu {
    &.is-active {
      .el-submenu__title {
        color: #EB5461;
        background-color: #FFE4E7 !important;

        .iconfont, span {
          color: #EB5461;
        }
      }

      .el-menu--inline {
        .el-menu-item {
          &.is-active {
            &:hover {
              background-color: #FFE4E7 !important;
            }
          }
        }
      }
    }

    .el-submenu__title:hover {
      background-color: #FFE4E7 !important;

      .iconfont, span {
        color: #EB5461;
      }
    }

    /deep/ .el-submenu__title {
      &:hover {
        background-color: #FFE4E7 !important;
      }
    }

    .el-menu--inline {
      .el-menu-item {
        &:hover {
          background-color: #FFE4E7 !important;

          span {
            color: #EB5461;
          }
        }
      }
    }
  }

  .el-menu-item {
    &:hover {
      background-color: #FFE4E7 !important;

      .iconfont, span {
        color: #EB5461;
      }
    }

    &.is-active {
      background-color: #FFE4E7 !important;

      .iconfont, span {
        color: #EB5461 !important;
      }
    }
  }

  .el-submenu.is-active /deep/.el-submenu__title {
    color: #EB5461;
    background-color: #FFE4E7 !important;
  }
}

html[data-theme='init'] {
  .el-submenu {
    &.is-active {
      .el-submenu__title {
        color: #1972FF;
        background-color: #E8F1FF !important;

        .iconfont, span {
          color: #1972FF;
        }
      }

      .el-menu--inline {
        .el-menu-item {
          &.is-active {
            &:hover {
              background-color: #E8F1FF !important;
            }
          }
        }
      }
    }

    .el-submenu__title:hover {
      background-color: #E8F1FF !important;

      .iconfont, span {
        color: #1972FF;
      }
    }

    /deep/ .el-submenu__title {
      &:hover {
        background-color: #E8F1FF !important;
      }
    }

    .el-menu--inline {
      .el-menu-item {
        &:hover {
          background-color: #E8F1FF !important;

          span {
            color: #1972FF;
          }
        }
      }
    }
  }

  .el-menu-item {
    &:hover {
      background-color: #E8F1FF !important;

      .iconfont, span {
        color: #1972FF;
      }
    }

    &.is-active {
      background-color: #E8F1FF !important;

      .iconfont, span {
        color: #1972FF !important;
      }
    }
  }

  .el-submenu.is-active /deep/.el-submenu__title {
    color: #1972FF;
    background-color: #E8F1FF !important;
  }
}
</style>
